import * as React from "react";
import {Nav, Navbar} from "react-bootstrap";
import {ROUTE_ACTIVITIES, ROUTE_CONTACT, ROUTE_EVENTS, ROUTE_HOME} from "../../routing/Routes";
import ItemLink from "./ItemLink";
import onClickOutside from "react-onclickoutside";
import {FormattedMessage} from "react-intl";

interface NavBarProps {
    currentRoute: string,
}

type Props = NavBarProps;

class NavBar extends React.Component<Props> {

    // usado por la clase onClickOutside
    private handleClickOutside = (event: any): void => {
        this.handleClickMenu();
    };

    private handleClickMenu = (): void => {
        const buttonNode: any = document.getElementsByClassName('navbar-toggler');
        if (buttonNode.length !== 0) {
            if (buttonNode[0].className !== 'navbar-toggler collapsed') {
                buttonNode[0].click();
            }
        }
    }

    public render(): React.ReactNode {
        const {currentRoute} = this.props;

        return (
            <Navbar expand="lg" className={"navbar"}>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav">

                    <Nav className="mr-auto">

                        <ItemLink linkName={<FormattedMessage id={'club.title'}/>}
                                  linkTo={ROUTE_HOME}
                                  active={ROUTE_HOME === currentRoute}
                        />
                        <ItemLink linkName={<FormattedMessage id={'events.title'}/>}
                                  linkTo={ROUTE_EVENTS}
                                  active={ROUTE_EVENTS === currentRoute}
                        />
                        <ItemLink linkName={<FormattedMessage id={'activities.title'}/>}
                                  linkTo={ROUTE_ACTIVITIES}
                                  active={ROUTE_ACTIVITIES === currentRoute}
                        />
                        <ItemLink linkName={<FormattedMessage id={'contact.title'}/>}
                                  linkTo={ROUTE_CONTACT}
                                  active={ROUTE_CONTACT === currentRoute}
                        />

                    </Nav>

                </Navbar.Collapse>
            </Navbar>
        )
    }

}

export default onClickOutside(NavBar) as unknown as React.ComponentType<NavBarProps>;